module.exports = __webpack_public_path__ + "assets/8ac02af50b3376c6c1def06112a42682.png";